import React, { useState, useEffect } from 'react';
import { Table, InputNumber, Button, message } from 'antd';
import axios from 'axios';
import { buildApiUrl } from '../config/api';
import '../styles/Common.css'; // 공통 스타일

const CapaPage = () => {
  const [capaData, setCapaData] = useState([]);
  const [editingCapa, setEditingCapa] = useState({});

  // CAPA 데이터를 가져오는 함수
  const fetchCapaData = async () => {
    try {
      const response = await axios.get(buildApiUrl('/api/order/capa'));
      setCapaData(response.data);
    } catch (error) {
      console.error('CAPA 데이터를 불러오는 중 오류 발생:', error);
      message.error('CAPA 데이터를 불러오는 중 오류가 발생했습니다.');
    }
  };

  useEffect(() => {
    fetchCapaData(); // 페이지 로드 시 CAPA 데이터를 가져옴
  }, []);

  // CAPA 값을 수정할 때 호출되는 함수
  const handleCapaChange = (value, partName) => {
    setEditingCapa((prev) => ({ ...prev, [partName]: value }));
  };

  // 수정한 CAPA 값을 저장하는 함수
  const handleSave = async (partName) => {
    const updatedCapa = editingCapa[partName];

    if (updatedCapa === undefined) {
      message.warning('수정된 CAPA 값이 없습니다.');
      return;
    }

    try {
      const response = await axios.post(buildApiUrl('/api/capa/update'), {
        partName,
        capa: updatedCapa,
      });

      if (response.status === 200) {
        message.success('CAPA 값이 저장되었습니다.');
        setEditingCapa((prev) => ({ ...prev, [partName]: undefined })); // 저장 후 수정값 초기화
        fetchCapaData(); // 데이터 다시 가져오기
      } else {
        message.error('CAPA 값 저장에 실패했습니다.');
      }
    } catch (error) {
      console.error('CAPA 값 저장 중 오류 발생:', error);
      message.error('CAPA 값 저장 중 오류가 발생했습니다.');
    }
  };

  const columns = [
    {
      title: '품목명',
      dataIndex: 'PartName',
      key: 'PartName',
      align: 'center',
    },
    {
      title: 'CAPA 값',
      dataIndex: 'CAPA',
      key: 'CAPA',
      align: 'center',
      render: (text, record) => (
        <InputNumber
          min={0}
          defaultValue={record.CAPA}
          value={editingCapa[record.PartName] !== undefined ? editingCapa[record.PartName] : record.CAPA}
          onChange={(value) => handleCapaChange(value, record.PartName)}
        />
      ),
    },
    {
      title: '수정',
      key: 'action',
      align: 'center',
      render: (text, record) => (
        <Button type="primary" onClick={() => handleSave(record.PartName)}>
          저장
        </Button>
      ),
    },
  ];

  return (
    <div className="common-container">
      <h1>품목별 CAPA 관리</h1>
      <Table
        dataSource={capaData}
        columns={columns}
        rowKey="PartName"
        pagination={false}
        bordered
      />
    </div>
  );
};

export default CapaPage;
